import { Action } from '@ngrx/store';

export enum EManufacturerActions {
    GetAllManufacturers = '[Manufacturers] Get All Manufacturers',
    GetAllManufacturersSuccess = '[Manufacturers] Set All Manufacturers Success',
    GetAllManufacturersError = '[] Set All Manufacturers Error',
    AddManufacturer = '[Manufacturers] Add Manufacturers',
    GetAddManufacturerSuccess = '[Manufacturers] Set Add Manufacturers Success',
    GetAddManufacturerError = '[] Set Add Manufacturers Error',
    EditManufacturer = '[Manufacturers] Edit Manufacturers',
    GetEditManufacturerSuccess = '[Manufacturers] Set Edit Manufacturers Success',
    GetEditManufacturerError = '[] Set Edit Manufacturers Error',
    GetManufacturerBystatusId = '[Manufacturers] Get Manufacturers By Status Id',
    GetManufacturerBystatusIdSuccess = '[Manufacturers] Get Manufacturers By Status Id Success',
    GetManufacturerBystatusIdError = '[] Get Manufacturers By Status Id Error',
    
}

export class GetAllManufacturers implements Action {
    public readonly type = EManufacturerActions.GetAllManufacturers;
    constructor(public payload: any) {}
}

export class GetAllManufacturersSuccess implements Action {
    public readonly type = EManufacturerActions.GetAllManufacturersSuccess;
    constructor(public payload: any) {}
}

export class GetAllManufacturersError implements Action {
    public readonly type = EManufacturerActions.GetAllManufacturersError;
    constructor(public payload: any) {}
}

export class AddManufacturer implements Action {
    public readonly type = EManufacturerActions.AddManufacturer;
    constructor(public payload: any) {}
}

export class GetAddManufacturerSuccess implements Action {
    public readonly type = EManufacturerActions.GetAddManufacturerSuccess;
    constructor(public payload: any) {}
}

export class GetAddManufacturerError implements Action {
    public readonly type = EManufacturerActions.GetAddManufacturerError;
    constructor(public payload: any) {}
}

export class EditManufacturer implements Action {
    public readonly type = EManufacturerActions.EditManufacturer;
    constructor(public payload: any, public param: any) {}
}

export class GetEditManufacturerSuccess implements Action {
    public readonly type = EManufacturerActions.GetEditManufacturerSuccess;
    constructor(public payload: any) {}
}

export class GetEditManufacturerError implements Action {
    public readonly type = EManufacturerActions.GetEditManufacturerError;
    constructor(public payload: any) {}
}
export class GetManufacturerBystatusId implements Action {
    public readonly type = EManufacturerActions.GetManufacturerBystatusId;
    constructor(public payload: any) {}
}
export class GetManufacturerBystatusIdSuccess implements Action {
    public readonly type = EManufacturerActions.GetManufacturerBystatusIdSuccess;
    constructor(public payload: any) {}
}
export class GetManufacturerBystatusIdError implements Action {
    public readonly type = EManufacturerActions.GetManufacturerBystatusIdError;
    constructor(public payload: any) {}
}

export type ManufacturerAction =   GetAllManufacturers | GetAllManufacturersSuccess | GetAllManufacturersError |
                            AddManufacturer | GetAddManufacturerSuccess | GetAddManufacturerError |
                            EditManufacturer | GetEditManufacturerSuccess | GetEditManufacturerError |
                            GetManufacturerBystatusId | GetManufacturerBystatusIdSuccess|
                            GetManufacturerBystatusIdError;